import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiPost, operationsClient } from '@/lib/api';
import { leadEndpoints } from '@/lib/api/endpoints';
import { leadKeys } from '@/lib/queryKeys';
import { useApiMutation } from '../useApiMutation';
import type { BulkAssignLeadsDto, Lead } from '@/types/lead';

interface BulkAssignLeadsResult {
  count: number;
  leads: Lead[];
}

export function useBulkAssignLeads() {
  const queryClient = useQueryClient();

  return useApiMutation<BulkAssignLeadsResult, BulkAssignLeadsDto>({
    mutationFn: (dto) =>
      apiPost<BulkAssignLeadsResult, BulkAssignLeadsDto>(
        operationsClient,
        leadEndpoints.bulkAssign(),
        dto,
      ),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: leadKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: leadKeys.pipeline() });
      // Invalidate (not setQueryData) so an opened detail refetches via
      // GET /leads/:id, the only path that resolves departed-owner names
      // (NOT-486).
      data.leads.forEach((lead) => {
        void queryClient.invalidateQueries({ queryKey: leadKeys.detail(lead.id) });
      });
      toast.success(`${data.count} lead${data.count === 1 ? '' : 's'} assigned`);
    },
  });
}
